import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as inventoryService from "../../services/inventoryService";
import ExportMenu from "../../components/InventoryExport/ExportMenu";
import InventoryTable from "./InventoryTable";
import LowStockBadge from "./LowStockBadge";
import { formatDecimal } from "../../utils/numberFormat";

const COLUMNS = [
  { key: "name", label: "Item", render: (row) => `${row.name} (${row.sku})` },
  { key: "category_name", label: "Category" },
  { key: "current_qty", label: "Current qty", format: "number", render: (row) => formatDecimal(row.current_qty) },
  { key: "reorder_level", label: "Reorder level", format: "number", render: (row) => formatDecimal(row.reorder_level) },
  { key: "status", label: "Status", render: (row) => <LowStockBadge currentQty={row.current_qty} reorderLevel={row.reorder_level} /> },
];

function LowStockView() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    inventoryService
      .getLowStockItems()
      .then((res) => setItems(res?.data || []))
      .catch((err) => toast.error(err.message || "Could not load low-stock items"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Low Stock Alerts</h4>
        <ExportMenu rows={items} columns={COLUMNS} filenameBase="low_stock_alerts" onExportPdf={(html) => inventoryService.exportReportPdf("low-stock", html)} />
      </div>
      <InventoryTable
        columns={COLUMNS}
        data={items}
        loading={loading}
        showSearch={false}
        onRowClick={(row) => navigate(`/inventory/${row.id}`)}
        emptyMessage="Nothing is low on stock right now."
      />
    </div>
  );
}

export default LowStockView;
